import React from 'react';
import { connect } from 'dva';
import { injectIntl } from 'react-intl';
import RoomReportAbnormallyDetail from '../components/report/RoomReportAbnormallyDetail';

export default connect(state => ({ ...state, loading: state.loading.global }))(
  injectIntl(({ roomReportDetails, loading, intl, dispatch }) => {
    return (
      <div className="container-left">
        <RoomReportAbnormallyDetail
          intl={intl}
          dispatch={dispatch}
          loading={loading}
          roomReportDetails={roomReportDetails}
        />
      </div>
    );
  })
);



// WEBPACK FOOTER //
// ./src/routes/RoomAbnormalDetail.js